import crudActions from '../../crud/actions'

const actions = crudActions('HR_CONDITION_')

export default actions
